import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { SUBMENU } from "../utils/constants";
import AdminDashboard from "../pages/AdminDashboard";

export default function AdminEntry() {
  const navigate  = useNavigate();
  const location  = useLocation();

  // helper: obține primul tab valid din SUBMENU.admin
  const defaultTab = SUBMENU.admin[0].slug; // "echipe"

  useEffect(() => {
    const params      = new URLSearchParams(location.search);
    const orgParam    = params.get("org");      // club-slug
    const tabParam    = params.get("tab");      // "echipe" | "antrenori" …
    const validTabs   = SUBMENU.admin.map((i) => i.slug);

    // recuperează org din session, dacă lipsește
    const session     = JSON.parse(localStorage.getItem("session") || "{}");
    const orgFromSess = session?.organization?.organization_slug || "";

    // condiții de redirect
    const needOrg = !orgParam || orgParam.trim() === "";
    const needTab = !tabParam || !validTabs.includes(tabParam);

    if (needOrg || needTab) {
      const finalOrg = needOrg ? orgFromSess : orgParam;
      const finalTab = needTab ? defaultTab : tabParam;

      navigate(`/admin?org=${finalOrg}&tab=${finalTab}`, { replace: true });
    }
  }, [location.search, navigate]);

  // URL este valid → randăm dashboard-ul
  return <AdminDashboard />;
}
